// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import xLoadingOverlay from "@steiner/App/Handlers/XNG/LoadingOverlay";
import { AccountSummaryModel, getAccountSummaryDashboard } from "@steiner/App/Services/AccountSummary";

export interface LoadAccountSummaryDashboardApiParameter extends ApiParameter {}

type HandlerType = ApiHandler<
    LoadAccountSummaryDashboardApiParameter & HasOnSuccess<AccountSummaryModel> & HasOnError,
    AccountSummaryModel
>;

export const BeginLoadAccountSummary: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", id: "LoadAccountSummary" }));
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const GetSummaryDashboard: HandlerType = async props => {
    try {
        props.apiResult = await getAccountSummaryDashboard();
    } catch (error) {
        props.dispatch(xLoadingOverlay({ key: "remove", id: "LoadAccountSummary" }));
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "remove", id: "LoadAccountSummary" }));
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [BeginLoadAccountSummary, PopulateApiParameter, GetSummaryDashboard, ExecuteOnSuccessCallback];

const loadAccountSummaryDashboard = createHandlerChainRunner(chain, "LoadAccountSummaryDashboard");
export default loadAccountSummaryDashboard;
